import {useContext, useEffect, useReducer } from "react"
import React from 'react'
import html2pdf from 'html2pdf.js'
import reducer from './reducer'
import data from './data'

const AppContext = React.createContext()

const initialState = {
  checkout: false,
  total: 0,
  players: [data],
  dropdown: [],
  page: '1'
}

const AppProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const addToCart = (e) => {
    let target = e.target;
    dispatch({ type: 'ADD_ITEM', payload: { target } })
  }

  const searchPlayers = (word) => {
    dispatch({type: 'SEARCH_ITEM', payload: {word}})
  }

  const removePlayer = (e) => {
    console.log(e.target.parentElement.previousElementSibling.firstElementChild.textContent)
    dispatch({ type: 'DELETE_ITEM', payload: e.target.parentElement.previousElementSibling.firstElementChild.textContent })
  }

  const clearItems = () => {
    dispatch({ type: 'CLEAR_ITEMS' })
  }

  const changePage = (e) => {
    e.target.blur();
    let num = e.target.textContent;
    dispatch({type: 'CHANGE_PAGE', payload: num})
  }

  const checkOut = () => {
    if (state.dropdown.length === 5)
      dispatch({ type: 'CHECK' })
  }

  const share = () => {
    html2pdf(document.body);
  }

  useEffect(() => {
    dispatch({type:'CALCULATE_TOTAL'})
  },[state.dropdown])
  
  return (
      <AppContext.Provider
      value={{ addToCart,searchPlayers,removePlayer,clearItems,changePage,checkOut,share, ...state}}
      >
        {children}
      </AppContext.Provider>
    )
}   

  export const useGlobalContext = () => {
      return useContext(AppContext)
    }
    
  export { AppContext, AppProvider }